import React from 'react';

interface WhiteBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  showShadow?: boolean;
}

function WhiteBox({
  className,
  showShadow = false,
  children,
  ...props
}: WhiteBoxProps) {
  return (
    <div
      className={`bg-white rounded-huge border border-skyblue ${className} ${
        showShadow ? 'shadow-skyblue-200' : ''
      }`}
      {...props}
    >
      {children}
    </div>
  );
}

export default WhiteBox;
